






























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTask,
} from "../models";

import taskStateColors from "../taskstates";

import LoadTaskListItem from "./LoadTaskListItem.vue";

@Component({
    components: {
        LoadTaskListItem
    }
})
export default class LoadTaskSelect extends Vue {
    @Prop() extended!: boolean;
    @Prop() loads!: TransportLoad[];
    @Prop() value!: null | { load: TransportLoad; loadTask: TransportLoadTask };

    taskStateColors = taskStateColors;

    hasLoadAlert(load: TransportLoad) {
        return (
            load.loadState !== "Done" &&
            !load.loadTasks.find(lt => lt.task && lt.task.state !== "Ready")
        );
    }

    getLinesText(loadTask: TransportLoadTask): string {
        const items = [];

        for (const line of loadTask.task.lines) {
            items.push(line.partDescription);
        }

        return items.join(", ");
    }

    select(value: { load: TransportLoad, loadTask: TransportLoadTask }) {
        this.$emit("input", value);
    }
}
